module.exports = __webpack_public_path__ + "img/consCab.9e366ba3.jpg";